import axios from "axios";
import { setErrorMessage } from "./common";
import {
    setAlerts,
    setAlertsLoading,
    setPortalDisplayFlags,
    setPythonIntegrations,
} from "../reducers/config";
import { AppThunk } from "../redux/store";
import { Alert } from "../typeDefs/configuration";

export const getPortalConfigFlags = (): AppThunk<void> => (dispatch) => {
    axios
        .get("api/config/flags")
        .then((res) => {
            dispatch(setPortalDisplayFlags(res.data));
        })
        .catch((err) => {
            console.error(err);
            dispatch(setErrorMessage("Couldn't get portal config data"));
        });
};

export const getPythonIntegrations = (): AppThunk<void> => (dispatch) => {
    axios
        .get("api/config/python")
        .then((res) => {
            dispatch(setPythonIntegrations(res.data));
        })
        .catch((err) => {
            console.error(err);
            dispatch(setErrorMessage("Couldn't get enabled python"));
        });
};

export const getAlerts = (): AppThunk<void> => (dispatch) => {
    dispatch(setAlertsLoading(true));
    axios
        .get<Alert[]>("api/config/alerts")
        .then((res) => {
            dispatch(setAlerts(res.data));
            dispatch(setAlertsLoading(false));
        })
        .catch((err) => {
            console.error(err);
            dispatch(setErrorMessage("Couldn't get enabled python"));
            dispatch(setAlertsLoading(false));
        });
};
